export default "/images/ACCC.png?d6bbe7c07b56bb295ca070c644c33ab6";